import { CollaborationController } from './CollaborationController';
import { CollaborationTexts } from './CollaborationTexts';
import { Modal } from '../../atoms/Modal/Modal';
import { html } from 'rune-ts';
import klass from './CollaborationModal.module.scss';
import { CollaborationBodyView } from './CollaborationBody';

export type CollaborationFactoryData = {
  collaborationController: CollaborationController;
};

export class CollaborationModalFactory {
  collaborationController: CollaborationController;
  collaborationBodyView: CollaborationBodyView;

  private readonly texts = CollaborationTexts.texts();

  constructor(data: CollaborationFactoryData) {
    this.collaborationController = data.collaborationController;
    this.collaborationBodyView = new CollaborationBodyView({
      collaborationController: this.collaborationController,
    });
  }

  public getModal = () => {
    return new Modal({
      size: 'large',
      title: this.texts.title,
      body: this.collaborationBodyView,
      isOpen: false,
      enable_app_bottom_padding: true,
      footer: html`
        <div class="${klass.buttons}">
          ${this.collaborationController.cancelButton} ${this.collaborationController.submitButton}
        </div>
      `,
    });
  };
}
